const de = {
  label: "Feedback",
  placeholder: {
    label: "John Doe",
    initials: "JD",
  },
};

export default de;
